import React from 'react'

import './Titlebar.css';

function Titlebar() {
  return (
    <div className="titlebar">
      <span className="titlebar-title">
        <h1>Datenverwaltung Knit+</h1>
      </span>
      <span className="titlebar-logo">
        {/* Bild aus public */}
        <img src="logo_tud.png" alt="LOGOTUDD"/>
      </span>
    </div>
  )
}

export default Titlebar
